import React from 'react'
import { connect } from '@cerebral/react'
import { state, props } from 'cerebral/tags'

export default connect(
  {
    tags: state`${props`path`}.*`
  },
  ({ tags = {}, renderTag, path }) => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {Object.keys(tags).map(key => {
          if (tags[key] === 'form') return null
          return renderTag({
            path: `${path}.${tags[key]}`,
            key: key
          })
        })}
      </div>
    )
  }
)



// WEBPACK FOOTER //
// ./src/components/Common/PillContainer/pillContainer.js